/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingtypestory2Inputs */

const en_crosspostingtypestory2 = /** @type {(inputs: Crosspostingtypestory2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story`)
};

const de_crosspostingtypestory2 = /** @type {(inputs: Crosspostingtypestory2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story`)
};

/**
* | output |
* | --- |
* | "Story" |
*
* @param {Crosspostingtypestory2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingtypestory2 = /** @type {((inputs?: Crosspostingtypestory2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingtypestory2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingtypestory2(inputs)
	return de_crosspostingtypestory2(inputs)
});
export { crosspostingtypestory2 as "crosspostingTypeStory" }